import axios from "axios";



export default function UpdateProgress(props) {
  
  var doneUpdate = false;
  console.log(props);
  var progressValue = 0;


  //send the value plus one
  if (props.rankings != undefined) {
    var progressValue = parseInt(props.rankings.progress) + 1;
  } else {
    var progressValue = 0;
  }
  let service_id;
  if (props.gameData != undefined && props.rankings.service_id != undefined) {
    service_id = props.gameData.find(gd => gd.service_key == props.rankings.service_key).id;
  }
  else {
    if (props.game != null){
      service_id = props.game.id;
    }else{
      return "fail";
    }
  }

  //var params = { service_id: service_key, progress: progressValue};

  axios({
    url: `${process.env.REACT_APP_API}/ratings/progress`,
    method: "post",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${props.token.access_token}`
    },
    data: {
      "progress": progressValue,
      "service_id": service_id.toString()
    }
  });

  return "success";
}

